import React, { useMemo } from 'react';
import ConfirmationModal from '../../../../components/modals/ConfirmationModal';

const BulkReturnConfirmationModal = ({
    isOpen,
    toggle,
    onConfirmBulkReturn,
    isLoading,
    selectedItemsForReturn, // Expects array of {id, status}
    statusChecked, // Expects an object like { statusName: boolean }
    onStatusChange, // Expects function (statusName) => void
}) => {
    const statusCounts = useMemo(() => {
        return selectedItemsForReturn.reduce((acc, item) => {
            acc[item.status] = (acc[item.status] || 0) + 1;
            return acc;
        }, {});
    }, [selectedItemsForReturn]);

    const handleConfirm = () => {
        // The logic to filter selectedItemsForReturn based on statusChecked
        // and then extract IDs will be handled by the onConfirmBulkReturn callback
        // provided by the parent, as it has direct access to the necessary states.
        if (onConfirmBulkReturn) {
            onConfirmBulkReturn();
        }
    };

    const canConfirm = useMemo(() => {
        if (!selectedItemsForReturn || selectedItemsForReturn.length === 0) return false;
        return selectedItemsForReturn.some(item => statusChecked[item.status] !== false); // Allow confirm if at least one status group is checked (or not explicitly unchecked)
    }, [selectedItemsForReturn, statusChecked]);


    return (
        <ConfirmationModal
            isOpen={isOpen}
            toggleFn={toggle}
            title={'Confirm Returning Multiple Leads'}
            loadingState={isLoading}
            dimButtons
            disableConfirm={!canConfirm}
            actionFn={handleConfirm}
        >
            <p style={{ fontWeight: '500', fontSize: '14px', color: 'red', marginBottom: '4px' }}>
                Your action cannot be undone once you return the leads.
            </p>
            <span>Are you sure you want to return these lead(s)?</span>
            <br />
            <span style={{ fontSize: '12px', marginTop: '2px' }}>
                Uncheck leads if you dont want to proceed return for specific status
            </span>

            {Object.keys(statusCounts).length > 0 && (
                <ul className="bg-gray-200 p-4 rounded-md mt-2">
                    {Object.entries(statusCounts).map(([status, count]) => (
                        <li
                            key={status}
                            style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}
                        >
                            <input
                                type="checkbox"
                                checked={statusChecked[status] !== false} // Default to checked if not in statusChecked or true
                                onChange={() => onStatusChange(status)}
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    marginRight: '5px',
                                    verticalAlign: 'middle',
                                }}
                            />
                            <span
                                style={{ lineHeight: '20px' }}
                            >{`${count} lead(s) with status "${status}"`}</span>
                        </li>
                    ))}
                </ul>
            )}
        </ConfirmationModal>
    );
};

export default BulkReturnConfirmationModal;